import { gql } from '@apollo/client';

export const ARBEITSBEREICHE_BY_STANDORT_IDS = gql(`
  query rotationsplan_arbeitsbereicheByStandortIds($standortIds: [String!]!) {
   mitarbeiter_arbeitsbereicheByStandortIds(standortIds: $standortIds){
      id
      markierung 
      name
   }
  }
`);
